var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isMobileOnly } from 'react-device-detect';
export var isSsr = typeof window === 'undefined';
export var getHost = function () {
    if (isSsr)
        return '';
    if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
        return "https://".concat(window.location.hostname);
    }
    return window.location.origin;
};
export var getChannelID = function () { return (isMobileOnly ? 2 : 1); };
export var generateXB3TraceID = function () {
    return Math.random().toString(16).substring(2) +
        new Date().getTime().toString(16).substring(0, 15);
};
export var transformToTrialsObj = function (_a) {
    var _b;
    var data = _a.data;
    var trials = {};
    (_b = data === null || data === void 0 ? void 0 : data.features) === null || _b === void 0 ? void 0 : _b.forEach(function (feature) {
        trials[feature] = true;
    });
    return trials;
};
export var filterOutPII = function (_a) {
    var data = _a.data;
    var firstName = data.firstName, lastName = data.lastName, phoneNumber = data.phoneNumber, email = data.email, userAddress = data.userAddress, customer = data.customer, needed = __rest(data, ["firstName", "lastName", "phoneNumber", "email", "userAddress", "customer"]);
    var customerPhone = customer.phoneNumber, accountName = customer.accountName, neededFromCustomer = __rest(customer, ["phoneNumber", "accountName"]);
    return __assign(__assign({}, needed), { customer: __assign({}, neededFromCustomer) });
};
export var getMaskedPhoneNumber = function (phone) {
    if (!phone)
        return '';
    return "******".concat(phone.slice(-4));
};
export var getHyphenatedPhoneNumber = function (phone) {
    var phoneNumber = phone.replace(/\D/g, '');
    var phoneLength = phoneNumber.length;
    if (phoneLength > 3 && phoneLength <= 6) {
        return "".concat(phoneNumber.substring(0, 3), "-").concat(phoneNumber.substring(3));
    }
    if (phoneLength > 6) {
        return "".concat(phoneNumber.substring(0, 3), "-").concat(phoneNumber.substring(3, 6), "-").concat(phoneNumber.substring(6, 10));
    }
    return phoneNumber;
};
export var sanitizePhoneNumber = function (phoneNumber) {
    return phoneNumber.replace(/[-]/g, '');
};
var getPrimaryPhone = function (phones) {
    return phones === null || phones === void 0 ? void 0 : phones.find(function (value) { return value.primaryFlag === 'Y'; });
};
var getPhonePreferenceNumber = function (phone) {
    var _a;
    return phone.preferenceType
        ? parseInt((_a = phone.preferenceType) === null || _a === void 0 ? void 0 : _a.replace(/phn/i, ''), 10)
        : 9999;
};
var getSortedAltPhones = function (phones) {
    return phones === null || phones === void 0 ? void 0 : phones.filter(function (value) { return value.primaryFlag !== 'Y'; }).sort(function (phone1, phone2) {
        return getPhonePreferenceNumber(phone1) - getPhonePreferenceNumber(phone2);
    }).map(function (value, index) { return (__assign(__assign({}, value), { id: index })); });
};
export var getConfigurationValue = function (value) {
    var _a;
    return typeof window !== 'undefined'
        ? (_a = window.__EXPERIENCE_PROPS__) === null || _a === void 0 ? void 0 : _a.expConfiguration[value]
        : '';
};
export var mapResponseToCustomerModel = function (response) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    var customerProfile = (_a = response.accountProfile) === null || _a === void 0 ? void 0 : _a.customerProfile;
    var companyDetails = customerProfile
        ? {
            companyName: customerProfile.businessName,
            address: ((_b = customerProfile.address) === null || _b === void 0 ? void 0 : _b[0].postalDetails.addressLine1) || '',
            addressLine2: (_c = customerProfile.address) === null || _c === void 0 ? void 0 : _c[0].postalDetails.addressLine2,
            companyPhone: getPrimaryPhone(customerProfile.phones),
            businessType: customerProfile.tradeType,
            city: ((_d = customerProfile.address) === null || _d === void 0 ? void 0 : _d[0].postalDetails.city) || '',
            state: ((_e = customerProfile.address) === null || _e === void 0 ? void 0 : _e[0].postalDetails.state) || '',
            zipCode: ((_f = customerProfile.address) === null || _f === void 0 ? void 0 : _f[0].postalDetails.zipCode) || '',
            altPhones: getSortedAltPhones(customerProfile.phones),
        }
        : undefined;
    return {
        firstName: ((_g = response.accountProfile) === null || _g === void 0 ? void 0 : _g.userProfile.name.firstName) ||
            ((_j = (_h = response.account) === null || _h === void 0 ? void 0 : _h.profile.name) === null || _j === void 0 ? void 0 : _j.firstName),
        lastName: ((_k = response.accountProfile) === null || _k === void 0 ? void 0 : _k.userProfile.name.lastName) ||
            ((_m = (_l = response.account) === null || _l === void 0 ? void 0 : _l.profile.name) === null || _m === void 0 ? void 0 : _m.lastName),
        zipCode: (_o = response.account) === null || _o === void 0 ? void 0 : _o.profile.zipCode,
        phones: ((_p = response.accountProfile) === null || _p === void 0 ? void 0 : _p.userProfile.phones) ||
            ((_r = (_q = response.account) === null || _q === void 0 ? void 0 : _q.profilePhones) === null || _r === void 0 ? void 0 : _r.phone),
        taxExemptId: ((_s = response.accountProfile) === null || _s === void 0 ? void 0 : _s.customerProfile.taxExemptId) ||
            ((_u = (_t = response === null || response === void 0 ? void 0 : response.account) === null || _t === void 0 ? void 0 : _t.profile) === null || _u === void 0 ? void 0 : _u.taxExemptId),
        localStoreId: ((_v = response.accountProfile) === null || _v === void 0 ? void 0 : _v.userProfile.localStoreId) ||
            ((_x = (_w = response === null || response === void 0 ? void 0 : response.account) === null || _w === void 0 ? void 0 : _w.profile) === null || _x === void 0 ? void 0 : _x.localStoreId),
        companyDetails: companyDetails,
        accountOwner: ((_y = response.accountProfile) === null || _y === void 0 ? void 0 : _y.userProfile.accountOwner) || 'N',
        emailId: ((_0 = (_z = response.accountProfile) === null || _z === void 0 ? void 0 : _z.userProfile) === null || _0 === void 0 ? void 0 : _0.emailId) ||
            ((_1 = response === null || response === void 0 ? void 0 : response.account) === null || _1 === void 0 ? void 0 : _1.profile.emailId),
        response: response,
    };
};
export var mapTradeTypes = function (data) { return ({
    tradeTypes: data === null || data === void 0 ? void 0 : data.tradeTypes.map(function (_a) {
        var typeEnumeration = _a.typeEnumeration, typeDescription = _a.typeDescription, segment = _a.segment;
        return ({
            type: typeEnumeration,
            businessCategory: segment,
            description: typeDescription,
        });
    }),
}); };
export var getTmxId = function () {
    var _a, _b, _c;
    var nativeTMXID = '';
    if ((_a = window.__EXPERIENCE_CONTEXT__) === null || _a === void 0 ? void 0 : _a.isConsumerApp) {
        nativeTMXID = getUrlParam('guid');
    }
    return nativeTMXID || ((_c = (_b = window.THD_ACCOUNT_LIB) === null || _b === void 0 ? void 0 : _b.TMX) === null || _c === void 0 ? void 0 : _c.getTMXsessionId());
};
export var getNativeStoreID = function () {
    var _a;
    var nativeStoreId = '';
    var storeParam = ((_a = window.__EXPERIENCE_CONTEXT__) === null || _a === void 0 ? void 0 : _a.isConsumerApp)
        ? getUrlParam('storeid')
        : '';
    if (storeParam) {
        nativeStoreId = storeParam;
    }
    return nativeStoreId;
};
export var getUrlParam = function (key) {
    var _a;
    var searchParams = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search : '';
    var urlParams = new URLSearchParams(searchParams);
    return urlParams.get(key);
};
export var convertToMDYYYY = function (date) {
    return new Date(date).toLocaleDateString('en-US');
};
export var scrollToTop = function () {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
};
export var smoothScroll = function () {
    document.documentElement.style.scrollBehavior = 'smooth';
};
export var getReCaptchaKey = function () {
    if (typeof window !== 'undefined') {
        if (window.location.hostname.endsWith('homedepot.com')) {
            return '6LcGXvclAAAAAM7ZE9BVUDtZ_x5jDvPB4Ml1fYwK';
        }
        if (window.location.hostname.includes('qa74')) {
            return '6LeNZeAlAAAAAGEsAyo1uZoTvfgSdLUdlfyWpIYp';
        }
        if (window.location.hostname.includes('qa71')) {
            return '6LcjiJMlAAAAAK7W4IzEyg1u9Ls7hML6cSgJOh1U';
        }
    }
    return '';
};
export var isRecaptchaEnabled = function (isB2B) {
    return ((isB2B &&
        getConfigurationValue('B2B_PROFILE_INVISIBLE_RECAPTCHA_ENABLED') ===
            '1') ||
        (!isB2B &&
            getConfigurationValue('B2C_PROFILE_INVISIBLE_RECAPTCHA_ENABLED') === '1'));
};
export var isRecaptchaEnterprise = function () {
    return getConfigurationValue('RECAPTCHA_ENTERPRISE') === '1';
};
export var minimumRecaptchaLength = function () {
    return Number(getConfigurationValue('MINIMUM_RECAPTCHA_LENGTH'));
};
export var getCookieByName = function (name) {
    var _a;
    var prefix = "".concat(name, "=");
    var cookieValue = (_a = document.cookie
        .split('; ')
        .find(function (row) { return row.startsWith(prefix); })) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    return cookieValue ? decodeURI(cookieValue) : null;
};
export var updateCurrentDefaultAdrFields = function (newAdr, curAdr) {
    var _a, _b, _c, _d;
    var curName = curAdr.name, curPrimaryPhone = curAdr.primaryPhone, curPostalDetails = curAdr.postalDetails;
    var newName = newAdr.name, newPrimaryPhone = newAdr.primaryPhone, newPostalDetails = newAdr.postalDetails;
    return __assign(__assign({}, curAdr), { name: __assign(__assign({}, curName), { 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            firstName: ((_a = curName === null || curName === void 0 ? void 0 : curName.firstName) === null || _a === void 0 ? void 0 : _a.trim()) || (newName === null || newName === void 0 ? void 0 : newName.firstName.trim()), 
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            lastName: ((_b = curName === null || curName === void 0 ? void 0 : curName.lastName) === null || _b === void 0 ? void 0 : _b.trim()) || (newName === null || newName === void 0 ? void 0 : newName.lastName.trim()) }), primaryPhone: ((_c = curPrimaryPhone === null || curPrimaryPhone === void 0 ? void 0 : curPrimaryPhone.number) === null || _c === void 0 ? void 0 : _c.trim())
            ? __assign({}, curPrimaryPhone) : __assign(__assign({}, newPrimaryPhone), { 
            // BE looks for the presence of this property and it determines if it is an "UPDATE" or "INSERT" action
            // undefined means that it will be an "INSERT"
            id: undefined }), postalDetails: __assign(__assign({}, curPostalDetails), { addressLine1: ((_d = curPostalDetails === null || curPostalDetails === void 0 ? void 0 : curPostalDetails.addressLine1) === null || _d === void 0 ? void 0 : _d.trim()) || newPostalDetails.addressLine1 }), isDefault: false });
};
export var checkIsInviteExpirationEnabled = function () {
    return getConfigurationValue('USER_INVITE_EXPIRATION_ENABLED') === 'true';
};
